import { formatGroupedSigned } from '../number/grouped-signed';

/**
 * A served fraction (0.084) or basis points (840) as a percentage with a
 * fixed number of places and thousands separators: "8.4%", "−4.2%",
 * "1,250.0%". Signed only when the figure as printed is not zero; `plus`
 * marks a gain explicitly ("+8.4%") where a reader compares signs down a
 * column.
 */
export function formatSignedPercent(
  value: number,
  {
    unit = 'fraction',
    digits = 1,
    plus = false
  }: { unit?: 'fraction' | 'bps'; digits?: number; plus?: boolean } = {}
): string {
  const percent = unit === 'bps' ? value / 100 : value * 100;
  return `${formatGroupedSigned(percent, { digits, plus })}%`;
}
